module.exports = __webpack_public_path__ + "static/media/Source Info.39d8c1ef.txt";